import { useRef } from "react";
import styled from "styled-components";
import { Colors } from "../config/Constants";

type SearchType = {
  placeholder: string;
  onChange: (value: any) => void;
  value: string;
  width?: string;
};

const Search = ({ placeholder, onChange, value, width = "186px" }: SearchType) => {
  const inputRef: any = useRef(null);
  const onButtonClick = () => {
    inputRef.current.value = "";
    onChange("");
  };
  const handleKeyDown = (e: any) => {
    let key = e.code || e.keyCode;
    if (key === "Enter" || key === 13) {
      inputRef.current.blur();
    }
  };
  return (
    <SearchWrapper>
      <SearchInput
        onKeyDown={handleKeyDown}
        type="text"
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        value={value}
        ref={inputRef}
        width={width}
      />
      {value.length > 0 && (
        <ClearWrapper>
          <ClearIcon
            src={require("../assets/images/icn_clear search.png")}
            alt="clear"
            onClick={onButtonClick}
          />
        </ClearWrapper>
      )}
    </SearchWrapper>
  );
};

export default Search;

const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const SearchInput = styled.input<{ width: string }>` 
  width: ${(props) => props.width}; 
  height: 48px;
  border: 1px solid ${Colors.magnolia};
  box-shadow: 0px 12px 24px rgba(0, 72, 217, 0.05);
  border-radius: 0.5rem;
  padding: 0 22px;
  background: ${Colors.white};
  background: url(${require("../assets/images/search-normal.png")}) no-repeat;
  background-position-x: calc(100% - 18px);
  background-position-y: calc(50%);
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 500;
  font-size: 0.75rem;
  line-height: 13px;

  &:focus {
    outline: none;
  }
  &:not(:placeholder-shown) {
    background: none;
  }
  &::placeholder {
    color: ${Colors.mischka};
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
  }
`;

const ClearWrapper = styled.div`
  position: relative;
  transform: translate(-2rem, -0.5rem);
`;

const ClearIcon = styled.img`
  cursor: pointer;
  width: 0.75rem;
  height: 0.75rem;
  position: absolute;
  padding: 0.125rem 0.625rem 0 0;
  background: white;
`;
